<template>
  <b-col sm="12" :lg="size" :offset-lg="offset">
    <div class="animated fadeIn">
      <DateModal :modalID="typeParam" :fetchData="fetchData" :dateFrom="dateFrom" :dateTo="dateTo"
        @date-picker-modal-emit="onDatePickerModalEmit"></DateModal>
      <b-card class="backClass">
        <div slot="header" style="display:flex; justify-content: space-between;  align-items: center;">
          <HeaderTitle :title="title" :dateFrom="from ? from : dateFrom" :dateTo="to ? to : dateTo"></HeaderTitle>
          <HeaderControl :showFullscreenIcon="true" :showDateIcon="true" :showDownloadPdfIcon="true"
            :showDownloadExcelIcon="true"
            @emit-fullscreen="toggleFullScreen" @emit-date="modalDateEvent(typeParam)" @emit-pdf-download="downloadPDF"
            @emit-excel-download="downloadExcel">
          </HeaderControl>
        </div>
        <div class="chart-wrapper">
          <div v-if="loadingData" class="centered_container">
            <LoadingCard></LoadingCard>
          </div>
          <highcharts ref="backRef" v-else :options="chartOptions" class="chart" :constructor-type="'chart'">
          </highcharts>
        </div>
        <div slot="footer">
          <b-button :disabled="!showAll" class="btn-outline" variant="outline-primary" left
            @click="(showAll = false), fetchData()">Top 10
          </b-button>
          <b-button :disabled="showAll" class="btn-outline float-right" variant="outline-primary" right
            @click="(showAll = true), fetchData()">All Data
          </b-button>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import { chartOptionsFailureMixin } from "./addons/chartOptionsFailureMixin.js";
import { chartFunctionsMixin } from "./addons/chartFunctionsMixin.js";
import LoadingCard from "../shared/LoadingCard.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import DateModal from "../shared/DateModal.vue";

exporting(Highcharts);

export default {
  mixins: [chartOptionsFailureMixin, chartFunctionsMixin],
  components: {
    highcharts: Chart,
    Highcharts,
    DateModal,
    LoadingCard,
    HeaderTitle,
    HeaderControl
  },
  props: ["size", "offset", "part", "type", "title"],
  data: function () {
    return {
      partNum: "",
      typeParam: ""
    };
  },
  methods: {
    downloadExcel() {

      this.loading2019 = true;
      let params = {};
      params = {
        fns_part: this.partNum,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        xml: "true",
      };
    
      if (this.title === "Failure By Part") {
      this.excelDownload = "api/teleste/tables/failureDataByPart.php";
      }

      if (this.title === "Failure By Designator") {
      this.excelDownload = "api/teleste/tables/failureDataByDesignator.php";
      }

      if (this.title === "Failure By Complaint") {
        this.excelDownload = "api/teleste/tables/failureDataByComplaint.php";
      }
    
      if (this.title === "Failure By Failure") {
        this.excelDownload = "api/teleste/tables/failureDataByFailure.php";
      }
      
        this.$http
          .get(this.excelDownload, {
            params,
            responseType: "blob"
          })
          .then(
            res => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "TableReport.xlsx");
              document.body.appendChild(link);
              link.click();
              this.loading2019 = false;
            },
            err => {
              this.loading2019 = false;
              console.log(err);
            }
          );
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        fns_part: this.partNum,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      };
      this.$http
        .get("api/teleste/products/getFailureDataBy" + this.typeParam + ".php", {
          params
        })
        .then(
          res => {
            if (!this.showAll) {
              this.chartOptions.series[0].data = res.data.slice(0, 10);
            } else {
              this.chartOptions.series[0].data = res.data;
            }
            this.chartOptions.title.text = "Total units: " + res.data.totals;

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    }
  },
  mounted() {
    this.typeParam = this.type;
    this.partNum = this.part;
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.highcharts-exporting-group {
  display: none !important;
}

.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
/* Uniform icon button sizing and spacing */
.card-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.card-header-actions .btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 14px;
}
.card-header-actions .fa-file-excel-o {
  transform: none !important;
}
</style>
